import React, { useEffect, useState, useMemo } from "react";
import Papa from "papaparse";

const SubPics = ({ currentStyle, data=[], onImageClick, color }) => {
  const [currentItem, setCurrentItem] = useState(null);

  useEffect(() => {
    setCurrentItem(null);
    if (data.length > 0) {
      const found = data.find(
        (item) =>
          item.Style?.trim() === currentStyle?.trim() &&
          item.Color?.trim() === color?.trim()
      );
      setCurrentItem(found || null);
    }
    
  }, [data, currentStyle, color]);

  // Extract unique images
const uniqueImages = useMemo(() => {
  if (!currentItem) return [];

  const images = [
    currentItem.DefaultImageSrc,
    currentItem.HoverImageSrc,
    currentItem.FRONT_FLAT,
    currentItem.BACK_FLAT,
    currentItem.FRONT_MODEL,
    currentItem.BACK_MODEL,
    currentItem.SIDE_MODEL,
    currentItem.THREE_Q_MODEL,
    currentItem.model,
    currentItem.back,
    currentItem.front,
    currentItem.ImageSrc,
    currentItem.img
  ]
    .filter(
      (img) =>
        img !== null &&
        img !== undefined &&
        img !== 0 &&
        img !== "0" &&
        typeof img === "string" &&
        img.trim() !== ""
    )
    .map((img) => img.trim());

  return [...new Set(images)];
}, [currentItem]);

// console.log(uniqueImages)
  // Nothing to show if no match
  if (!currentItem || uniqueImages.length === 0) {
    return null;
  }

  return (
    <div style={{ display: "flex", gap: "8px", margin: "1rem 0" }}>
      {uniqueImages.map((imgUrl, idx) => (
        <img
          key={idx}
          src={imgUrl}
          alt={`${currentStyle} thumbnail ${idx + 1}`}
          style={{
            width: 58,
            height: 66,
            borderRadius: 4,
            cursor: "pointer",
            border: "3px solid #ccc",
            marginRight: "-2px",
          }}
          onClick={() => onImageClick?.(imgUrl)}
          onError={(e) => {
            e.currentTarget.src = "/images/placeholder.jpg";
          }}
        />
      ))}
    </div>
  );
};

export default SubPics;
